export const DEFAULT_CONFIG = {
  dev: {
    enableAccounts2Config: true,
  },
  beta: {
    enableAccounts2Config: false,
  },
  kappa: {
    enableAccounts2Config: false,
  },
  stage: {
    enableAccounts2Config: true,
  },
  production: {
    enableAccounts2Config: true,
  },
  prod: {
    enableAccounts2Config: true,
  },
};

export const AUTH_URL_3_0 = '/v3/oauth2';
export const SYNC_URL_3_0 = '/v3/oauth2/sso/sync';
export const OTP_CHALLENGE_ENDPOINT = '/v3/oauth2/otp/challenge';

// Guest signup can take longer than fetchWithTimeout's 3s default, so it gets
// its own, longer timeout. It stays un-retried since it creates an account.
export const GUEST_SIGNUP_TIMEOUT_MS = 7000;

/**
 * sessionStorage key used to hand the brand OTP sign in recaptcha image
 * challenge (captchaImage / assessmentId / tokenId) off to the migrate sign in
 * page. The captchaImage is too large for the redirect query string, so it is
 * stashed under this key and read back on the migrate sign in page. The same
 * literal is duplicated on the sso-fe side (MigrateSignInV2) — keep them in sync.
 */
export const BRAND_OTP_SIGNIN_CAPTCHA_KEY = 'brandOtpSigninCaptchaChallenge';

/**
 * Recaptcha enterprise site key by env (public client-side key). Used to
 * generate the recaptcha token for the brand OTP sign in flow.
 * TODO: replace the placeholder values with the real recaptcha site keys.
 */
export const RECAPTCHA_SITE_KEY = {
  dev: '6LccFZkpAAAAALZVVc40whwh2AVee0YcPvrGpyx2',
  beta: '',
  kappa: '',
  stage: '',
  production: '',
  prod: '',
};

// Base names; non-prod environments get a suffix, see getEnvCookieName()
export const SFLY3_VISID_COOKIE = 'sfly3_visid';
export const SFLY_FPID_COOKIE = 'sfly_fpid';
export const PERSIST_USER_LOGIN_COOKIE_NAME = 'persistUserLogin';

export const BASE_URLS_PROD = {
  dev: {
    token: {
      sfly: 'https://accounts.dev.shutterfly.com',
      tp: 'https://accounts.dev.tinyprints.com',
      mlt: 'https://accounts-dev.lifetouch.net',
      preschools: 'https://accounts-dev.lifetouch.net',
      prestige: 'https://accounts-dev.lifetouch.net',
      community: 'https://accounts-dev.lifetouch.net',
      ltsmiles: 'https://accounts-dev.d.applicationx.net',
      mycollection: 'https://accounts-dev.lifetouch.net',
    },
    sso: 'https://accounts.dev.shutterfly.com',
    api2: 'https://api2.dev.shutterfly.com',
    www: 'https://www.dev.shutterfly.com',
    tp: 'https://www.dev.tinyprints.com',
    share: 'https://share.dev.shutterfly.com',
    sflyaccount: 'https://accounts-api3.dev.shutterfly.com/accounts',
  },
  beta: {
    token: {
      sfly: 'https://accounts.beta.shutterfly.com',
      tp: 'https://accounts.beta.tinyprints.com',
      mlt: 'https://accounts-beta.lifetouch.net',
      preschools: 'https://accounts-beta.lifetouch.net',
      prestige: 'https://accounts-beta.lifetouch.net',
      community: 'https://accounts-beta.lifetouch.net',
      ltsmiles: 'https://accounts-beta.d.applicationx.net',
      mycollection: 'https://accounts-beta.lifetouch.net',
    },
    sso: 'https://accounts.beta.shutterfly.com',
    api2: 'https://api2.beta.shutterfly.com',
    www: 'https://www.beta.shutterfly.com',
    tp: 'https://www.beta.tinyprints.com',
    share: 'https://share.beta.shutterfly.com',
    sflyaccount: 'https://accounts-api3.dev.shutterfly.com/accounts',
  },
  kappa: {
    token: {
      sfly: 'https://accounts.kappa.shutterfly.com',
      tp: 'https://accounts.kappa.tinyprints.com',
      mlt: 'https://accounts-kappa.lifetouch.net',
      preschools: 'https://accounts-kappa.lifetouch.net',
      prestige: 'https://accounts-kappa.lifetouch.net',
      community: 'https://accounts-kappa.lifetouch.net',
      ltsmiles: 'https://accounts-kappa.d.applicationx.net',
      mycollection: 'https://accounts-kappa.lifetouch.net',
    },
    sso: 'https://accounts.kappa.shutterfly.com',
    api2: 'https://api2.kappa.shutterfly.com',
    www: 'https://www.kappa.shutterfly.com',
    tp: 'https://www.kappa.tinyprints.com',
    share: 'https://share.kappa.shutterfly.com',
    sflyaccount: 'https://accounts-api3.dev.shutterfly.com/accounts',
  },
  stage: {
    token: {
      sfly: 'https://accounts.stage.shutterfly.com',
      tp: 'https://accounts.stage.tinyprints.com',
      mlt: 'https://accounts-stage.lifetouch.net',
      preschools: 'https://accounts-stage.lifetouch.net',
      prestige: 'https://accounts-stage.lifetouch.net',
      community: 'https://accounts-stage.lifetouch.net',
      ltsmiles: 'https://accounts-stage.lifetouch.net',
      mycollection: 'https://accounts-stage.lifetouch.net',
    },
    sso: 'https://accounts.stage.shutterfly.com',
    api2: 'https://api2.stage.shutterfly.com',
    www: 'https://www.stage.shutterfly.com',
    tp: 'https://www.stage.tinyprints.com',
    share: 'https://share.stage.shutterfly.com',
    sflyaccount: 'https://accounts-api3.stage.shutterfly.com/accounts',
  },
  production: {
    token: {
      sfly: 'https://accounts.shutterfly.com',
      tp: 'https://accounts.tinyprints.com',
      mlt: 'https://accounts.lifetouch.com',
      preschools: 'https://accounts.lifetouch.com',
      prestige: 'https://accounts.prestigeportraits.com',
      community: 'https://accounts.lifetouch.com',
      ltsmiles: 'https://accounts.lifetouchsmiles.com',
      mycollection: 'https://accounts.lifetouch.com',
    },
    sso: 'https://accounts.shutterfly.com',
    api2: 'https://api2.shutterfly.com',
    www: 'https://www.shutterfly.com',
    tp: 'https://www.tinyprints.com',
    share: 'https://share.shutterfly.com',
    sflyaccount: 'https://accounts-api3.shutterfly.com/accounts',
  },
  prod: {
    token: {
      sfly: 'https://accounts.shutterfly.com',
      tp: 'https://accounts.tinyprints.com',
      mlt: 'https://accounts.lifetouch.com',
      preschools: 'https://accounts.lifetouch.com',
      prestige: 'https://accounts.prestigeportraits.com',
      community: 'https://accounts.lifetouch.com',
      ltsmiles: 'https://accounts.lifetouchsmiles.com',
      mycollection: 'https://accounts.lifetouch.com',
    },
    sso: 'https://accounts.shutterfly.com',
    api2: 'https://api2.shutterfly.com',
    www: 'https://www.shutterfly.com',
    tp: 'https://www.tinyprints.com',
    share: 'https://share.shutterfly.com',
    sflyaccount: 'https://accounts-api3.shutterfly.com/accounts',
  },
};

export const RESYNC_TOKENS = {
  dev: 22 * 60 * 60 + 55 * 60,
  stage: 22 * 60 * 60 + 55 * 60,
  prod: 22 * 60 * 60 + 55 * 60,
  production: 22 * 60 * 60 + 55 * 60,
};

export const IAM_FALLBACK_CONFIGS_PROD = {
  dev: {
    appClientId: '7jolpe9o8hgbe25vk1j7uushir',
    userPoolId: 'us-east-1_0AuXDy6NQ',
    region: 'us-east-1',
    endPointUrl: 'https://accounts.dev.shutterfly.com/v3/oauth2',
    socialEnabled: false,
    persistenceEnabled: true,
    elevationEnabled: true,
    elevationDuration: 600,
  },
  beta: {
    appClientId: '2go8vi75ukffvs0o6rcuostbn8',
    userPoolId: 'us-east-1_2IwUqV1Ig',
    region: 'us-east-1',
    endPointUrl: 'https://accounts.dev.shutterfly.com/v3/oauth2',
    socialEnabled: false,
    persistenceEnabled: true,
    elevationEnabled: true,
    elevationDuration: 86400,
  },
  kappa: {
    appClientId: '5tbuap46oflh5b619ju78d11ci',
    userPoolId: 'us-east-1_H4njTpOTJ',
    region: 'us-east-1',
    endPointUrl: 'https://accounts.dev.shutterfly.com/v3/oauth2',
    socialEnabled: false,
    persistenceEnabled: true,
    elevationEnabled: true,
    elevationDuration: 86400,
  },
  stage: {
    appClientId: '279bgt6gacnhmn9ukgu63qquh3',
    userPoolId: 'us-east-1_ZxZlA5Pgp',
    region: 'us-east-1',
    endPointUrl: 'https://accounts.stage.shutterfly.com/v3/oauth2',
    socialEnabled: false,
    persistenceEnabled: true,
    elevationEnabled: true,
    elevationDuration: 86400,
  },
  production: {
    appClientId: 't8oiif52mece6bleeas2pof0n',
    userPoolId: 'us-east-1_TmHzoQ69j',
    region: 'us-east-1',
    endPointUrl: 'https://accounts.shutterfly.com/v3/oauth2',
    socialEnabled: false,
    persistenceEnabled: true,
    elevationEnabled: true,
    elevationDuration: 86400,
  },
  prod: {
    appClientId: 't8oiif52mece6bleeas2pof0n',
    userPoolId: 'us-east-1_TmHzoQ69j',
    region: 'us-east-1',
    endPointUrl: 'https://accounts.shutterfly.com/v3/oauth2',
    socialEnabled: false,
    persistenceEnabled: true,
    elevationEnabled: true,
    elevationDuration: 86400,
  },
};

export const COOKIE_IFRAME_HTML = '/v3/oauth2/cookies.html';

export const DATA_LAYER_PAGE_TYPE_COOKIE_NAME = 'a_data_layer_page';
